import React from 'react'
import {connect} from 'react-redux'

import DomainListing from '../domainstep/DomainListing'
import * as Config from '../../config/Config'
import {getDomainInCartList} from "../../selectors/CartUtil";

function TopDomainListing(props) {

    if (props.queriedDomain === "") {
        return null
    }

    let topDomainListingData = []
    let topDomainsToAdd = Config.DOMAIN_AMOUNT_TOPDOMAINS

    const isAddedToCartQueried = props.domainsAddedToCart.includes(props.queriedDomain + "." + props.queriedDomainEnding)


    // add entered domain ending to the top and reduce items to be shown
    if (props.queriedDomainEnding !== "" && props.domainData[props.queriedDomainEnding]) {
        if (!isAddedToCartQueried) {
            topDomainListingData.push(props.queriedDomainEnding)
        }
        topDomainsToAdd--;
    }

    for (let i = 0; i < topDomainsToAdd; i++) {

        const iteratingDomain = props.domainOrder[i]

        // check if domain ending already added to the top
        if (iteratingDomain === props.queriedDomainEnding) {
            topDomainsToAdd++
        } else {

            const isAddedToCart = props.domainsAddedToCart.includes(props.queriedDomain + "." + iteratingDomain)

            if (!isAddedToCart) {
                topDomainListingData.push(iteratingDomain)
            }
        }
    }

    return (
        <div className="domain-step__domains-top">
            <DomainListing listData={topDomainListingData} tableLabel="Top Domains"/>
        </div>
    )
}

TopDomainListing.propTypes = {};

const mapStateToProps = (state) => {

    return {
        queriedDomain: state.domainCheck.queriedDomain,
        queriedDomainEnding: state.domainCheck.queriedDomainEnding,
        domainData: state.domainCheck.topLevelDomains.data,
        domainOrder: state.domainCheck.topLevelDomains.order,
        domainsAddedToCart: getDomainInCartList(state)
    }

}


const mapDispatchToProps = (dispatch) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps)(TopDomainListing)


/** WEBPACK FOOTER **
 ** ./src/containers/domainstep/TopDomainListing.js
 **/